import React from 'react';
import Select, { components } from 'react-select';
import { FaChevronDown } from 'react-icons/fa';

const DropdownIndicator = props => {
  const {
    selectProps: { menuIsOpen },
  } = props;

  const iconStyle = {
    transition: 'transform 0.3s ease',
    transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <components.DropdownIndicator {...props}>
      <FaChevronDown style={iconStyle} />
    </components.DropdownIndicator>
  );
};

const customStyles = {
  control: base => ({
    ...base,
    padding: '2px',
    borderRadius: '6px',
    borderColor: '#ced4da',
    backgroundColor: '#f8f9fa',
    transition: 'all 0.2s ease',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#58d0ff' : 'white',
    borderRadius: '6px',
    color: state.isFocused ? 'white' : 'black',
    padding: '10px 12px',
    transition: 'all 0.2s ease',
  }),
  menu: base => ({
    ...base,
    padding: '8px',
    zIndex: 9999,
    marginTop: 0,
  }),
};

const SelectContratos = ({ contratos, buscarHistoricoProspecto }) => {
  return (
    <Select
      className="mt-4"
      placeholder={
        contratos.length === 0
          ? 'Sem contratos encontrados.'
          : 'Selecione o contrato...'
      }
      isDisabled={contratos.length === 0}
      isSearchable={false}
      options={contratos.map(contrato => ({
        value: contrato.numero,
        label: `${contrato.numero} - ${contrato.empreendimento.nome} - ${contrato.imovel.quadra}/${contrato.imovel.lote}`,
      }))}
      onChange={option => {
        buscarHistoricoProspecto(option.value);
      }}
      styles={customStyles}
      components={{ DropdownIndicator }}
    />
  );
};

export default SelectContratos;
